import SelectedItem from "components/partials/selected-items/selected-item/selected-item";

import { TouchpointAttributes } from "hooks/api/use-touchpoints";

const SelectedItems = ({
  selectedList,
  showStatus = false,
  showBatch = false,
}: {
  selectedList: TouchpointAttributes[];
  showStatus?: boolean;
  showBatch?: boolean;
}) => {
  return (
    <div className="flex flex-col gap-2">
      <h2>Selected items</h2>
      <div className="flex flex-col gap-3 h-[130px] overflow-y-auto custom-scroll">
        {selectedList?.length ? (
          selectedList.map((item: TouchpointAttributes) => {
            return (
              <SelectedItem
                key={item.id}
                name={item.name}
                latestVersion={item.latestVersion}
                type={item.type}
                showStatus={showStatus}
                showBatch={showBatch}
                touchpointBatchName={item.touchpointBatchName}
              />
            );
          })
        ) : (
          <span className="text-gray-500 text-sm">No items selected yet.</span>
        )}
      </div>
    </div>
  );
};

export default SelectedItems;
